export default __webpack_public_path__ + "static/media/howtodevelop.68355935.svg";